import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BugFeedback } from "@anatida/bug-react";
import "@anatida/bug-react/style.css";
import App from "./App";
import "./styles.css";

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
    <BugFeedback
      appId="lappu"
      appName="Lappu"
      appVersion="0.1.0"
      view={window.location.pathname}
    />
  </StrictMode>,
);
